import { withStyles } from '@material-ui/styles';
import React, { useMemo } from 'react';

import DataRow from '../../Datarow/DataRow';
import { translate } from '../../../i18n/I18nProvider';
import styles from '../styles/info';
import StatusCell from '../../statusCell/StatusCell';
import pickOptionsForStatusCell from '../../statusCell/actions/pickOptionsForStatusCell';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import clsx from 'clsx';
import { Tooltip } from '@material-ui/core';
import ExclamationTriangleIcon from '../../customIcons/ExclamationTriangleIcon';

const MAX_RECHARGE_COUNT = 4;

const Info = ({ classes, data = {} }) => {
  const customClasses = useMemo(() => {
    return {
      dataRow: {
        root: classes.dataRow_root_short,
        value: classes.dataRow_value
      }
    };
  }, [classes]);

  return (
    <div className={classes.root}>
      <div className={classes.label}>Info and status</div>
      <div className={classes.infoContainer}>
        <div>
          <DataRow
            label={translate('CURRENT_STATUS')}
            value={
              <div className={classes.statusCellContainer}>
                <StatusCell
                  {...pickOptionsForStatusCell(
                    STATUS_BOX_OPTIONS.DATA_LIMITS,
                    data.status
                  )}
                />
                {data.update_mdu === true && (
                  <Tooltip title={translate('DATA_LIMITS.UPDATE_WARNING')}>
                    <ExclamationTriangleIcon customFontSize="12px" />
                  </Tooltip>
                )}
              </div>
            }
            customClasses={customClasses.dataRow}
            dense
          />
          <DataRow
            label={translate('NUMBER.AUTO_REFILL')}
            value={
              <div className={classes.statusCellContainer}>
                <StatusCell
                  {...pickOptionsForStatusCell(
                    STATUS_BOX_OPTIONS.SIMCARD_ACTIVE,
                    data.allow_recharge
                  )}
                />
                {data.update_mdu === true && (
                  <i
                    className={clsx(
                      'fa fa-exclamation-triangle',
                      classes.infoIcon,
                      classes.hiddenIcon
                    )}
                    aria-hidden="true"
                  ></i>
                )}
              </div>
            }
            customClasses={customClasses.dataRow}
            dense
          />
        </div>
        <div>
          <DataRow
            label={translate('NUMBER.ROAMING_BLOCK')}
            value={data.roaming_disabled ? translate('YES') : translate('NO')}
            customClasses={customClasses.dataRow}
            dense
          />
          <DataRow
            label={translate('NUMBER.RECHARGE_COUNT')}
            value={`${data.recharge_count}/${MAX_RECHARGE_COUNT}`}
            customClasses={customClasses.dataRow}
            dense
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Info);
